import { FormInput } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface IGerAcessoProps {
  namePrefix: string;
}

const translationPath = "page.4uBus.register.iService.";

export const GerAcesso = memo(({ namePrefix }: IGerAcessoProps) => {
  const { t } = useTranslation();

  const getName = (fieldName: string) => `${namePrefix}.${fieldName}`;

  return (
    <>
      <Grid item xs={12}>
        <FormInput
          size="small"
          name={getName("token")}
          label={t(translationPath + "token")}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <FormInput
          size="small"
          name={getName("baseUrl")}
          label={t(translationPath + "base_url")}
          fullWidth
        />
      </Grid>
    </>
  );
});
